/**
     * @includeToDoc
     */
export interface IValidatableControl {
    validationMessage: string;
    validity: ValidityState;
    checkValidity(): boolean;
    setCustomValidity(error: string): void;
}

/**
 * @includeToDoc
 */
export interface IInputControl extends IValidatableControl {
    value: string;
    valueAsNumber: number;
}
